// src/validations/userFormValidation.ts

import * as Yup from 'yup';
import {NAME_FIELD_CONFIG} from './constantsUtils';
import {IUserFormInput} from '../pages/admin/tnn-control/drc/users/CreateUserForm';

export const createNameSchema = (fieldKey: string) => {
  const config = NAME_FIELD_CONFIG[fieldKey];
  if (!config) {
    throw new Error(`Invalid fieldKey: ${fieldKey}`);
  }
  const pattern =
    config.pattern ??
    (config.allowSpaces ? /^[a-zA-Z0-9 ]+$/ : /^[a-zA-Z0-9]+$/);
  const patternMessage =
    config.patternMessage ??
    `${config.label} can only contain letters and numbers.`;

  return Yup.string()
    .required(`${config.label} is required.`)
    .matches(pattern, patternMessage)
    .min(
      config.min,
      `${config.label} must be at least ${config.min} characters.`,
    )
    .max(
      config.max,
      `${config.label} must be less than or equal to ${config.max} characters.`,
    );
};

export const userFormSchema = Yup.object({
  source: Yup.string().required('Source is required'),
  first_name: createNameSchema('first_name'),
  last_name: createNameSchema('last_name'),
  email: Yup.string().email('Invalid email').required('Email is required'),
  password: Yup.string()
    .notRequired()
    .when('$isCreating', {
      is: true,
      then: schema =>
        schema
          .required('Password is required')
          .matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/,
            'Must be at least 8 characters with upper, lower, number & special char',
          ),
    }),
  agency_company_name: Yup.string().required('Agency/Company name is required'),
  client_type: Yup.string()
    .oneOf(['advertising-agency', 'company'])
    .required('Client type is required'),
  client_name: Yup.string().when('client_type', {
    is: 'advertising-agency',
    then: schema => schema.required('Client name is required'),
    otherwise: schema => schema.optional(),
  }),
}) as Yup.ObjectSchema<IUserFormInput>;
